var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnlineSupportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_93_1458",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_93_1458",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAADxklEQVRoge2ZX2hWZRzHv8+Y7xR15ZwIRkG0tlLHQIpoKEkSrC4Ko0ZENwbBLvyDhF5MhOzCLboQ/yCiWHghXXYTlHkT4ahwUIyIkkAXW4GKTqdrf9+PF+d52Znvec8573uec84u/MLL4X3e3/P9fb/n+f+80iMsLhiXZECLpFckvSzpWUlPS1ohqVHSH5K2GWNuuMzpDMByYBfwK9EYAtbkrXkBgDqgB7gZw4AfM8AI8AvwFfAh8EReJtYAF6o0EIWLwAtZmmgBrjk2UUIROAksSdvEOuCflEz48QOwKi0T9cBPGZgo4TugLg0j+zI0UcIncfXFWkeA5ZKuSsp66pyS9IwxZjQqMG7T7VT2JiSpQdK+OIGRLQIYScOSnkwoqlaMS2o2xkyHBcVpkQ7lZ0KSVkrqjAqKY+SN5FoW4HdJE1XW6YoKiGPkpSqThuG0pBclvSNpsop67YkzA785mEYHgC0P8W4GRmPWH3Jh5HaN4ieB88DWEO7HgS9jcI25MBIXReAKcA54F2isIsdmvJW8IqI44ky/QSTD9nNN0p+SLksaNMYkenNAh6QdkvaUCTUm2SGwlreTFHhnlv3AapekeRj5OA3SPIw02+eAL+0o0A8UaiXN3EhYbqCvFqJli9BI4E44amXvTUFfUqwLKqyPqPSWfX4kqVXSdkn/ORSVDYBx25zLcsofiKDYqK5VWuDWupXoHlFGfrbPXrwD1mJA5LG3DMBGYNq26I/AQaAhBXGV8gfhcK1kXcAdH9F2x3rDcl/y5R0BDlPrgmgJG4FDlvCCQ61BuQzwtu+727UL74JuBG+73uKMuDzPa8AUsBtosj7Go+rFvskzxsxKOitv69+TQGsU9koqSGqR1GbLhp1mwLv7nQLuAk1OyT3+522LF4HngFO2RY65ziXgrCU/lAL3Gcv9NbAJ+B+YA9a7zlV6a3PALeCxkLgC8Bnwr2/muW7LyrZGwAa8A9Us8IEdjwAnnJvwJT1nkxwJiemnMsq24sC3pYHN/Np1kTS3R8BTttlngI0VYuJe9QShCBwHlqZmwif0U5t0oEJXqcXIFWtgQ+oGfEILzF/e9Qf83hciuM/G1AHf27JBkqzaSQB04F3EFYH3HvqtYM34W2bBYAeO2vJxoC04S0YAuvFmsRmgO2Ydw/xkMA28nrbOWAD2WFFzwOeE7JDx/tr+xsYXgR1Zao0E8D5wzwq8ChywXW+lFd9pu9KYjRkD3sxbdyCAduByyCAv4RLQmrfeUNj+34W3aP4NTAD3gb+AL4BX89b4CFngASWwMt+jSZU0AAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineSupportIcon);
export default __webpack_public_path__ + "static/media/online-support-icon.81f8e0401767f79171b805a89029da79.svg";
export { ForwardRef as ReactComponent };